<template>
    <div id='HeadBlocks' class='row'>
        <div class='col-3 WgacaLogo'>
            <img :src=logoSrc alt='WGACA' />
        </div>
        <div id ='LlamaSearch' class='col-5 col-md-7 text-right'>
            <Search />
        </div>
        <Notifications />
        <div class='col-2 col-md-1 AvatarImg text-center'>
            <img :src=AvatarSrc alt='User' />
        </div>
    </div>
</template>


<script>
    import Search from '../../form/Search.vue';
    import Notifications from './Notifications.vue';
    export default {
        name: 'SiteHeader',
        components: {
            Search,
            Notifications
        },
        data() {
            return {
                logoSrc: '/images/footer-logo.svg'
            }
        },
        computed: {
            AvatarSrc(){
                return this.$store.getters['Auth/avatar'];
            }
        }
    }
</script>
